export type PrayerTimes = {
  Imsak: string | null
  Gunes: string | null
  Ogle: string | null
  Ikindi: string | null
  Aksam: string | null
  Yatsi: string | null
}

export type DailyPrayerTime = {
  date: string // YYYY-MM-DD
  hijriDate?: string
  times: PrayerTimes
}

export type PrayerTimesData = {
  source: string
  districtId: string
  data: DailyPrayerTime[]
}

export type PrayerMethod = 'diyanet' | 'umm-al-qura'

export type LocationOption = {
  id: string
  name: string
  // Diyanet specific fields
  SehirID?: string
  SehirAdi?: string
  IlceID?: string
  IlceAdi?: string
  // Country
  UlkeID?: string
  UlkeAdi?: string
}

export type SelectedLocation = {
  method?: PrayerMethod
  countryId?: string
  countryName?: string
  stateId?: string
  stateName?: string
  districtId?: string
  districtName: string
  // New fields for in-house API
  latitude?: number
  longitude?: number
}

export const getLocationPrayerMethod = (
  location: SelectedLocation | null,
): PrayerMethod => {
  if (location?.method) return location.method

  // Locations saved by the current in-house implementation use coordinates.
  // Keeping this inference preserves existing users' selections after the method field is added.
  if (
    location?.latitude != null ||
    location?.longitude != null ||
    location?.districtId?.includes(',')
  ) {
    return 'umm-al-qura'
  }

  // Historical Diyanet selections used numeric district IDs. New users also start here.
  return 'diyanet'
}
